// removed by extract-text-webpack-plugin
module.exports = {"saveList":"saveList__3iD4ABuq","saveListHeader":"saveListHeader__35nlSHtR","saveListTag":"saveListTag__IE_PkYjw","item":"item__1MI4_cYo","itemTitle":"itemTitle__315_gqkD","actived":"actived__136m7B3E","close":"close__2Zeaya6W","itemName":"itemName__1G1jXlAP","nodata":"nodata__1rVLXDTY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYFilterBar/components/OYFilterBarSaveList/index.module.less
// module id = 762
// module chunks = 1